<template>
    <div v-if="rtgId" class="pie">
        <highcharts class="chart" ref="chart" :options="chartOptions"></highcharts>

    </div>
</template>

<script>

    import { Chart } from 'highcharts-vue';
    import HighchartsMore from 'highcharts/highcharts-more';
    import * as Highcharts from 'highcharts'
    import offlineExporting from "highcharts/modules/offline-exporting";
    import exporting from "highcharts/modules/exporting";
    HighchartsMore(Highcharts);
    offlineExporting(Highcharts)
    exporting(Highcharts)

    Highcharts.setOptions({
        colors: [
            '#cb5144',
            '#205d72',
            '#f4c543',
            '#c32974',
            '#e6f1ee',
            '#49a1be',
            '#b1ddcc'
        ]
    });

    export default {
        name: 'pieChart',
        components: {
            highcharts: Chart

        },
        data() {
            return {
                rtgId: null,
                totalCount: 0,
                grafCategoriesData: [],
                chartOptions: {
                    chart: {

                        plotShadow: false,
                        backgroundColor: null,
                        type: 'pie',
                        style: {

                            fontFamily: 'var(--font-family)'
                        },
                    },
                    exporting: {

                        buttons: {

                            contextButton: {

                                enabled: false,
                                menuItems: ['downloadPNG', 'downloadSVG', 'downloadPDF', 'viewFullscreen', 'printChart']
                            }
                        },
                        exportButton: {
                            text: '<i class="fa fa-download"></i> Download',
                            // Use only the download related menu items from the default context button

                        },
                        fallbackToExportServer: false
                    },

                    credits: {
                        enabled: false
                    },
                    title: {
                        text: 'SUCHFELD VERTEILUNG',
                        style: {
                            color: '#717c86 ',
                            fontSize: '21px',
                            fontWeight: 'bold',
                        }
                    },
                    tooltip: {
                        pointFormat: '<b>Suchfeld</b>: {point.longName} <br/><b>{series.name}</b>: {point.count}',

                    },
                    accessibility: {
                        point: {
                            valueSuffix: '%'
                        }
                    },
                    plotOptions: {

                        pie: {
                            size: "70%",
                            allowPointSelect: true,
                            cursor: 'pointer',
                            depth: 35,
                            dataLabels: {
                                formatter: function () {
                                    {
                                        return '<span class="labelPie">' + this.point.name + ":" + Highcharts.numberFormat(this.point.percentage, 2) + "%"+'</span>';
                                    }
                                },

                                style: {


                                    textOutline: false
                                },

                            },

                        }
                    },
                    series: [{
                        name: 'Themen',
                        colorByPoint: true,
                        data: this.seriesData,
                        animation: {
                            duration: 1500
                        }
                    }]
                }
            };
        },

        created() {



            window.addEventListener("rtgIdChanged", function () {

                this.rtgId = window.State.getRtgId()
                this.$store.dispatch("getSuchfeldStats", { RtgId: this.rtgId })
            }.bind(this), false)


        },
        watch: {
            seriesData: function (newVal, oldVal) {

                const chart = this.$refs["chart"].chart
                if (oldVal != newVal && chart.series) {
                    this.chartOptions.series[0].data = newVal

                    this.chartOptions.subtitle = { text: 'Themen Anzahl:' + this.totalCount }
                    chart.redraw();
                }
            }
        },
        computed: {
            suchfeldStats() { return this.$store.state.statisticsStore.suchfeldStats },
            seriesData() {
                var i = 0;
                var self = this;
                self.totalCount = 0;
                var seriesData = [];
                this.suchfeldStats.forEach(st => {


                    if (st.LitId && st.TopicCount) {
                        self.totalCount += st.TopicCount;
                      
                        if (st.LitShortName)
                            seriesData[i] = { name: st.LitShortName, y: st.TopicCount, count: st.TopicCount, longName: st.LitName };
                        else
                            seriesData[i] = { name: st.LitName, y: st.TopicCount, count: st.TopicCount, longName: st.LitName };


                        i++;
                    }
                })

                return seriesData;
            },
        },

    }

</script>
<style scoped>

    .chart {
        width: 600px
    }

    .bitv .labelPie {
        fill: black;
    }

    .labelPie {
        fill: whitesmoke;
        outline: none;
    }
</style>